import gql from "graphql-tag";

import {
  WorkplaceTenantFields,
  WorkplaceFields,
  WorkplaceDefaultFields,
} from "../workplaces";

import { ZONE_FIELDS_FRAGMENT } from "../zones/zones";
import { DESK_FIELDS_FRAGMENT } from "../desks/desks";
import { FLOOR_FIELDS_FRAGMENT } from "../floors/floors";
import { BUILDING_FIELDS_FRAGMENT } from "../buildings/buildings";
import { WAY_FINDER_FIELDS_FRAGMENT } from "../wayfinder/wayfinder";
import { MINIMAL_ROOM_FIELDS_FRAGMENT } from "../rooms/rooms";

export interface SiteFields extends WorkplaceDefaultFields {
  buildings?: WorkplaceFields[];
  floors?: WorkplaceFields[];
  zones?: WorkplaceFields[];
  rooms?: WorkplaceFields[];
  desks?: WorkplaceFields[];
  wayfinders?: WorkplaceFields[];
}

export interface UpdateSiteResponse {
  updateSite: {
    site: SiteFields[];
  };
}

export interface SiteRequestVariables extends WorkplaceTenantFields {
  id: string;
  name: string;
  tags: string[];
  description: string;
  remove?: {
    tags: string[];
  };
}

export interface AddSiteVariables extends WorkplaceTenantFields {
  name: string;
  tags: string[];
  description: string;
}

export interface AddSiteResponse {
  addSite: {
    site: SiteFields[];
  };
}

export const SITE_FIELDS_FRAGMENT = gql`
  fragment SiteFields on Site {
    id
    name
    tags
    description
    buildings(order: { asc: name }) {
      ...BuildingFields
    }
    floors(order: { asc: name }) {
      ...FloorFields
    }
    zones(order: { asc: name }) {
      ...ZoneFields
    }
    rooms(order: { asc: name }) {
      ...MinimalRoomFields
    }
    desks(order: { asc: name }) {
      ...DeskFields
    }
    wayfinders(order: { asc: name }) {
      ...WayfinderFields
    }
  }
  ${BUILDING_FIELDS_FRAGMENT}
  ${FLOOR_FIELDS_FRAGMENT}
  ${ZONE_FIELDS_FRAGMENT}
  ${MINIMAL_ROOM_FIELDS_FRAGMENT}
  ${DESK_FIELDS_FRAGMENT}
  ${WAY_FINDER_FIELDS_FRAGMENT}
`;

export const ADD_SITE_TO_TENANT = gql`
  mutation addSiteToTenantMutation(
    $id: ID
    $name: String
    $description: String
    $tags: [String]
    $tenantId: String!
  ) {
    addSite(
      input: [
        {
          name: $name
          tags: $tags
          description: $description
          tenantId: $tenantId
          tenant: { id: $id }
        }
      ]
    ) {
      site {
        ...SiteFields
      }
    }
  }
  ${SITE_FIELDS_FRAGMENT}
`;

export const ADD_SITE_TO_COMPANY = gql`
  mutation addSiteToCompanyMutation(
    $id: ID
    $name: String
    $description: String
    $tags: [String]
    $tenantId: String!
  ) {
    addSite(
      input: [
        {
          name: $name
          tags: $tags
          description: $description
          tenantId: $tenantId
          company: { id: $id }
        }
      ]
    ) {
      site {
        ...SiteFields
      }
    }
  }
  ${SITE_FIELDS_FRAGMENT}
`;

export const UPDATE_SITE = gql`
  mutation updateSiteMutation(
    $id: ID!
    $name: String
    $tags: [String]
    $description: String
    $tenantId: String!
    $remove: SitePatch
  ) {
    updateSite(
      input: {
        filter: { id: [$id] }
        set: {
          name: $name
          tags: $tags
          description: $description
          tenantId: $tenantId
        }
        remove: $remove
      }
    ) {
      site {
        ...SiteFields
      }
    }
  }
  ${SITE_FIELDS_FRAGMENT}
`;
